import React from 'react';
import { ParallaxImage } from './ui/ParallaxImage';
import { FadeInUp } from './ui/FadeInUp';
import { Phone, MapPin, Facebook, Instagram } from 'lucide-react';
export function FinalCTASection() {
  return <section className="relative py-24 md:py-32 min-h-[80vh] flex items-center" data-id="element-54">
      <ParallaxImage src="https://cdn.magicpatterns.com/uploads/auvmPhQzFd9zYH9uyAadd7/pexels-mario-ortiz-227262335-14667209.jpg" alt="Arizona red rock landscape at golden hour" overlayOpacity={0.55} data-id="element-55" />

      <div className="relative z-10 container mx-auto px-6" data-id="element-56">
        <div className="max-w-5xl mx-auto bg-ivory rounded-2xl shadow-2xl overflow-hidden flex flex-col lg:flex-row" data-id="element-57">
          {/* Form Side */}
          <div className="w-full lg:w-3/5 p-8 md:p-12 lg:p-16" data-id="element-58">
            <FadeInUp data-id="element-59">
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-60">
                Ready to start the conversation?
              </h2>
              <p className="text-charcoal-text/70 mb-8 text-lg" data-id="element-61">
                Whether you're buying, selling, or just exploring. We'd love to
                hear from you.
              </p>

              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-62">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-63">
                  <div data-id="element-64">
                    <label htmlFor="name" className="block text-sm font-medium text-charcoal mb-2" data-id="element-65">
                      Name *
                    </label>
                    <input type="text" id="name" required className="w-full h-12 px-4 bg-white border border-sand rounded focus:outline-none focus:ring-2 focus:ring-terracotta/50 focus:border-terracotta transition-colors" data-id="element-66" />
                  </div>
                  <div data-id="element-67">
                    <label htmlFor="email" className="block text-sm font-medium text-charcoal mb-2" data-id="element-68">
                      Email *
                    </label>
                    <input type="email" id="email" required className="w-full h-12 px-4 bg-white border border-sand rounded focus:outline-none focus:ring-2 focus:ring-terracotta/50 focus:border-terracotta transition-colors" data-id="element-69" />
                  </div>
                </div>
                <div data-id="element-70">
                  <label htmlFor="phone" className="block text-sm font-medium text-charcoal mb-2" data-id="element-71">
                    Phone
                  </label>
                  <input type="tel" id="phone" className="w-full h-12 px-4 bg-white border border-sand rounded focus:outline-none focus:ring-2 focus:ring-terracotta/50 focus:border-terracotta transition-colors" data-id="element-72" />
                </div>
                <div data-id="element-73">
                  <label htmlFor="message" className="block text-sm font-medium text-charcoal mb-2" data-id="element-74">
                    Message
                  </label>
                  <textarea id="message" rows={4} className="w-full p-4 bg-white border border-sand rounded focus:outline-none focus:ring-2 focus:ring-terracotta/50 focus:border-terracotta transition-colors resize-none" data-id="element-75"></textarea>
                </div>
                <button type="submit" className="w-full py-4 bg-terracotta text-white rounded font-medium hover:bg-terracotta/90 transition-colors shadow-md" data-id="element-76">
                  Send Message
                </button>
              </form>
            </FadeInUp>
          </div>

          {/* Contact Info Side */}
          <div className="w-full lg:w-2/5 bg-charcoal text-ivory p-8 md:p-12 lg:p-16 flex flex-col justify-between" data-id="element-77">
            <FadeInUp delay={0.2} data-id="element-78">
              <h3 className="text-2xl font-serif mb-8" data-id="element-79">Contact Information</h3>

              <div className="space-y-8" data-id="element-80">
                <div className="flex items-start" data-id="element-81">
                  <Phone className="w-6 h-6 text-terracotta mr-4 shrink-0" data-id="element-82" />
                  <div data-id="element-83">
                    <p className="text-sm text-ivory/60 mb-1 uppercase tracking-widest" data-id="element-84">
                      Office
                    </p>
                    <p className="text-lg" data-id="element-85">602.309.8888</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-86">
                  <Phone className="w-6 h-6 text-terracotta mr-4 shrink-0" data-id="element-87" />
                  <div data-id="element-88">
                    <p className="text-sm text-ivory/60 mb-1 uppercase tracking-widest" data-id="element-89">
                      Cell
                    </p>
                    <p className="text-lg" data-id="element-90">480.215.2324</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-91">
                  <MapPin className="w-6 h-6 text-terracotta mr-4 shrink-0" data-id="element-92" />
                  <div data-id="element-93">
                    <p className="text-sm text-ivory/60 mb-1 uppercase tracking-widest" data-id="element-94">
                      Address
                    </p>
                    <p className="text-lg leading-relaxed" data-id="element-95">
                      1455 W. Redondo Drive
                      <br data-id="element-96" />
                      Gilbert, AZ 85233
                    </p>
                  </div>
                </div>
              </div>
            </FadeInUp>

            <FadeInUp delay={0.3} className="mt-12 pt-12 border-t border-white/10" data-id="element-97">
              <p className="text-sm text-ivory/60 mb-4 uppercase tracking-widest" data-id="element-98">
                Follow Us
              </p>
              <div className="flex space-x-4" data-id="element-99">
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" aria-label="Facebook" data-id="element-100">
                  <Facebook className="w-4 h-4" data-id="element-101" />
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" aria-label="Instagram" data-id="element-102">
                  <Instagram className="w-4 h-4" data-id="element-103" />
                </a>
              </div>
            </FadeInUp>
          </div>
        </div>
      </div>
    </section>;
}